var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVolumeUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.448,
    height: 19.909,
    viewBox: "0 0 24.448 19.909",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "volume-up",
    d: "M13.356,3.051a1.626,1.626,0,0,0-.22.015,1.548,1.548,0,0,0-.823.374h0L7.183,8H3.5A2.516,2.516,0,0,0,1,10.5v5.006a2.516,2.516,0,0,0,2.5,2.5h3.68l5.129,4.559A1.557,1.557,0,0,0,14.9,21.407V4.6a1.581,1.581,0,0,0-.919-1.421,1.547,1.547,0,0,0-.629-.133Zm8.9,1.046a.834.834,0,0,0-.682,1.262,14.121,14.121,0,0,1,0,15.291.834.834,0,1,0,1.441.839,16.016,16.016,0,0,0,0-16.967.834.834,0,0,0-.761-.426Zm-9.02.755V21.159L8.054,16.553a.835.835,0,0,0-.554-.211h-4a.822.822,0,0,1-.834-.834V10.5A.822.822,0,0,1,3.5,9.668h4a.834.834,0,0,0,.554-.211ZM19.774,6.32a.834.834,0,0,0-.738,1.231,11.029,11.029,0,0,1,0,10.908.834.834,0,1,0,1.48.771,12.9,12.9,0,0,0,0-12.451.834.834,0,0,0-.742-.459ZM17.225,9.11a.834.834,0,0,0-.718,1.192,6.1,6.1,0,0,1,0,5.417.834.834,0,1,0,1.516.7,7.953,7.953,0,0,0,.005-6.808.834.834,0,0,0-.8-.5Z",
    transform: "translate(-1 -3.051)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolumeUp);
export default __webpack_public_path__ + "static/media/volume-up.3d0cdbbf1cb580493038d25cb0485660.svg";
export { ForwardRef as ReactComponent };